import React from 'react';
import { HelpCircle, ChevronRight } from 'lucide-react';
import Button from './Button';
import { useScrollReveal } from '../../hooks/useScrollReveal';

const FaqCTA: React.FC = () => {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>({ threshold: 0.2 });

  return (
    <div 
      ref={ref}
      className={`bg-gradient-to-r from-accent-sage/20 via-accent-sand/20 to-accent-rose/20 rounded-2xl p-8 md:p-12 shadow-soft transition-all duration-700 ease-out transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
    >
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-start md:items-center gap-4 flex-1">
          <div className="flex-shrink-0">
            <div className="w-14 h-14 bg-brand/10 rounded-full flex items-center justify-center">
              <HelpCircle className="text-brand" size={28} />
            </div>
          </div>
          <div className="text-center md:text-left">
            <h3 className="font-playfair text-xl md:text-2xl font-bold text-neutral-ink mb-2">
              Vous avez des questions ?
            </h3>
            <p className="font-nunito text-neutral-body">
              Consultez notre foire aux questions pour trouver rapidement des réponses à vos interrogations.
            </p>
          </div>
        </div>
        <div className="flex-shrink-0">
          <Button 
            variant="primary" 
            size="lg" 
            to="/faq"
            className="group relative overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
          >
            <span className="absolute inset-0 bg-gradient-to-r from-brand-dark to-brand opacity-0 group-hover:opacity-100 transition-opacity duration-500"></span>
            <span className="relative z-10 flex items-center justify-center gap-2 font-semibold group-hover:scale-105 transition-transform duration-300">
              <span>Voir la FAQ</span>
              <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FaqCTA;
